import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type RoadVisionCredTypes, roadVision } from '../standards.js'

export type qucaCredType = RoadVisionCredTypes
export const qucaDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const quca: CarrierDef<qucaCredType> = {
  name: 'Quality Cartage',
  scac: 'quca',
  ...roadVision,
  engineLayers: ['rating', 'pickup', 'documents', 'tracking', 'invoice'],
  documentTypes: qucaDocumentTypes,
}
